// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__2MNvS","image__browser":"index_image__browser__rd4zw"};